import React from "react";
import { I18nRichText } from "./inputs/I18nRichText";

export default function RichTextBlock({ block }) {
  if (!block) return null;

  const { fontType, customStyle, props } = block;
  const commonStyle = { display: "inline-block", margin: 0 };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "2em",
      }}
    >
      {fontType === "heading2" && (
        <h2 style={{ ...commonStyle, ...customStyle }}>
          <I18nRichText tKey={props.textKey} fallbackText={props.text} />
        </h2>
      )}
      {fontType === "heading3" && (
        <h3 style={{ ...commonStyle, ...customStyle }}>
          <I18nRichText tKey={props.textKey} fallbackText={props.text} />
        </h3>
      )}
      {fontType === "paragraph" && (
        <p style={{ ...commonStyle, whiteSpace: "pre-line", textAlign: "center" }}>
          <I18nRichText tKey={props.textKey} fallbackText={props.text} />
        </p>
      )}
    </div>
  );
}